import { useEffect, useRef, useState } from "react";
import { suscribirCapas, tapadaPorCapa } from "../helpers/capasFlotantes";

// Revisor E2E del paquete final, H2 (#1401 v5 × #1450): una tarjeta flotante
// no modal (la de la prueba gratuita / la de gracia) CEDE mientras una marca
// de acompañamiento de #1450 se solaparía con ella. Devuelve `[ref, cede]`:
// el `ref` va en la tarjeta, y con `cede` la tarjeta queda
// `visibility: hidden` (conserva su caja, así se puede volver a medir, y no
// recibe toques) hasta que la marca se cierre o se corra. El porqué de que
// ceda la tarjeta y no la marca está en `helpers/capasFlotantes.js`.
export default function useCedeAnteCapas(activo) {
  const ref = useRef(null);
  const [cede, setCede] = useState(false);
  useEffect(() => {
    if (!activo) {
      setCede(false);
      return undefined;
    }
    const evaluar = () => {
      const el = ref.current;
      setCede(tapadaPorCapa(el ? el.getBoundingClientRect() : null));
    };
    evaluar();
    const soltar = suscribirCapas(evaluar);
    window.addEventListener("resize", evaluar);
    return () => {
      soltar();
      window.removeEventListener("resize", evaluar);
    };
  }, [activo]);
  return [ref, activo && cede];
}
